"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _useMarkAllAsAcknowledged = _interopRequireDefault(require("../providers/ActivityAcknowledgement/useMarkAllAsAcknowledged"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = _useMarkAllAsAcknowledged.default;
exports.default = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJ1c2VNYXJrQWxsQXNBY2tub3dsZWRnZWQiXSwic291cmNlUm9vdCI6ImNvbXBvbmVudDovLy8iLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9ob29rcy91c2VNYXJrQWxsQXNBY2tub3dsZWRnZWQudHMiXSwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHVzZU1hcmtBbGxBc0Fja25vd2xlZGdlZCBmcm9tICcuLi9wcm92aWRlcnMvQWN0aXZpdHlBY2tub3dsZWRnZW1lbnQvdXNlTWFya0FsbEFzQWNrbm93bGVkZ2VkJztcblxuZXhwb3J0IGRlZmF1bHQgdXNlTWFya0FsbEFzQWNrbm93bGVkZ2VkO1xuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUE7Ozs7ZUFFZUEsaUMifQ==